export const formatTimeAgo = (dateString, language = 'en', nowOverride = null) => {
    if (!dateString) return '';
    try {
        const date = new Date(dateString);
        const now = nowOverride || new Date();
        const seconds = Math.floor((now - date) / 1000);

        const lang = language || 'en';

        // Если разница отрицательная (будущее), считаем как "только что" в пределах разумного
        if (seconds < 0) {
            return lang === 'ru' ? 'только что' : 'just now';
        }

        if (seconds < 60) return lang === 'ru' ? 'только что' : 'just now';

        const minutes = Math.floor(seconds / 60);
        if (minutes < 60) {
            if (lang === 'ru') {
                if (minutes === 1 || (minutes % 10 === 1 && minutes !== 11)) return `${minutes} минуту назад`;
                if ([2, 3, 4].includes(minutes % 10) && ![12, 13, 14].includes(minutes)) return `${minutes} минуты назад`;
                return `${minutes} минут назад`;
            }
            return `${minutes} minutes ago`;
        }

        const hours = Math.floor(minutes / 60);
        if (hours < 24) {
            if (lang === 'ru') {
                if (hours === 1 || (hours % 10 === 1 && hours !== 11)) return `${hours} час назад`;
                if ([2, 3, 4].includes(hours % 10) && ![12, 13, 14].includes(hours)) return `${hours} часа назад`;
                return `${hours} часов назад`;
            }
            return `${hours} hours ago`;
        }

        const days = Math.floor(hours / 24);
        if (lang === 'ru') {
            if (days === 1 || (days % 10 === 1 && days !== 11)) return `${days} день назад`;
            if ([2, 3, 4].includes(days % 10) && ![12, 13, 14].includes(days)) return `${days} дня назад`;
            return `${days} дней назад`;
        }
        return `${days} days ago`;
    } catch (e) {
        return '';
    }
};